const openModalBtn = document.querySelector('.flexifit-icon');
const modalOverlay = document.getElementById('flexifitmodalOverlay');
const closeModalBtn = document.getElementById('closeModal');

function openModal(e) {
    e.preventDefault();
    modalOverlay.classList.add('active');
    document.body.classList.add('modal-open');
    const modal = document.querySelector(".flexifit-modal-content");
    const titleElement = modal.querySelector(".title.globo-heading");
    if (titleElement) {
        titleElement.textContent = "Flexi-Fit Customer Enquiry";
    }
}

function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.classList.remove('modal-open');
}

openModalBtn?.addEventListener('click', (e) => openModal(e));
closeModalBtn?.addEventListener('click', closeModal);

modalOverlay?.addEventListener('click', function(e) {
    if (e.target === modalOverlay) {
        closeModal();
    }
});

document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modalOverlay?.classList.contains('active')) {
        closeModal();
    }
});

document.querySelector('.flexifit-modal')?.addEventListener('click', function(e) {
    e.stopPropagation();
});

function initFlexifit(container) {
    const flexifitBannerContainer = container.querySelector(".flexifit-text-banner-container");
    if (!flexifitBannerContainer) return;

    const weeklyPrice = flexifitBannerContainer.getAttribute("data-weekly-price");
    const flexifitBannerText = flexifitBannerContainer.querySelector(".flexifit-text p strong");
    
    if (!weeklyPrice || !flexifitBannerText || parseFloat(weeklyPrice) <= 0) {
        flexifitBannerContainer.style.display = "none";
        return;
    }

    const formattedPrice = parseFloat(weeklyPrice).toFixed(2);
    flexifitBannerText.textContent = `$${formattedPrice} Per week`;
}

document.addEventListener("DOMContentLoaded", function() {
    initFlexifit(document);
});

document.addEventListener('variant:change', function() {
    initFlexifit(document);
});
